export const blank = {
	type: 'object',
	required: ['title'],
	properties: {
		title: {
			type: 'string',
			minLength: 1
		}
	},
	errorMessage: {
		required: 'validationFieldRequired',
		properties: {
			title: 'validationFieldRequired'
		}
	}
};
